import React from 'react';
import { Hero } from '../components/home/Hero';
import { Sectors } from '../components/home/Sectors';
import { Problem } from '../components/home/Problem';
import { Patterns } from '../components/home/Patterns';
import { TransitionBlock } from '../components/home/TransitionBlock';
import { Methodology } from '../components/home/Methodology';
import { Solutions } from '../components/home/Solutions';
import { Process } from '../components/home/Process';
import { DiagnosticCTA } from '../components/home/DiagnosticCTA';
import { FAQ } from '../components/home/FAQ';
import { FinalCTA } from '../components/home/FinalCTA';
export function Home() {
  return <div className="w-full" data-id="element-426">
      <Hero data-id="element-427" />
      <Sectors data-id="element-428" />
      <Problem data-id="element-429" />
      <Patterns data-id="element-430" />
      <TransitionBlock data-id="element-431" />
      <Methodology data-id="element-432" />
      <Solutions data-id="element-433" />
      <Process data-id="element-434" />
      <DiagnosticCTA data-id="element-435" />
      <FAQ data-id="element-436" />
      <FinalCTA data-id="element-437" />
    </div>;
}